import { render, staticRenderFns } from "./formUserList.vue?vue&type=template&id=2841f208&scoped=true&"
import script from "./formUserList.vue?vue&type=script&lang=js&"
export * from "./formUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841f208",
  null
  
)

export default component.exports